import { createModel } from '@rematch/core';

type LoadingState = {
  isLoading: boolean;
};

const setLoading = function handleSetLoading(
  state: LoadingState,
  isLoading: boolean
): LoadingState {
  return { ...state, isLoading };
};

const loading = createModel({
  state: { isLoading: false },
  reducers: { setLoading }
});

export default loading;
